<template>
  <div>
    <div v-for="item in props.options" class="payment-selector__option" :class="{ 'payment-selector__option--not-allowed': !item.allowed }" :data-idpayment="item.id" :key="item.id">
      <label class="cursor-pointer">
        <div class="payment-selector__option__row">
          <div class="payment-selector__option__cell flex pt-[4px] w-8">
            <AtomsFormsRadio name="payment" v-model="model" :value="item.id" @change="updateSelectedId(item)" :preventDefault="!item.allowed" />
          </div>

          <div v-if="item.idSystemType in appConfig.paymentIconsBySystemTypeId" class="payment-selector__option__cell flex-1 w-10 text-center tablet:flex-none">
            <AtomsImagesIcon :icon="appConfig.paymentIconsBySystemTypeId[item.idSystemType]" size="xl" class="mr-4" />
          </div>

          <div class="payment-selector__option__cell flex items-center justify-between gap-4 w-full tablet:flex-1">
            <strong>
              <span class="align-middle">{{ item.name }}</span>
              <AtomsImagesIcon :icon="appConfig.paymentAdditionalIconsBySystemTypeId[item.idSystemType]" size="xl" class="ml-3" />
            </strong>
            <AtomsImagesImage v-if="item.idSystemType === appConfig.paymentSystemTypeIds.online" src="/img/cardcompanies.png" class="w-40" />
          </div>

          <strong v-if="item.allowed" class="payment-selector__option__cell flex-1 w-16 self-center tablet:ml-0 tablet:flex-none tablet:text-right" :class="{ 'uppercase text-success-500': item.price === 0 }">{{ locale.formatPrice(item.price, true) }}</strong>

          <div v-if="item.notAllowedReasons?.length" class="flex-1 text-warning-600 tablet:text-right">
            {{ item.notAllowedReasons[0] in appConfig.reasonsToShowUnallowedPayments ? $t(appConfig.reasonsToShowUnallowedPayments[item.notAllowedReasons[0]]) : '' }}
          </div>

        </div>
        <div v-if="props.modelValue?.id === item.id && item.description" class="mt-4 text-sm tablet:mt-6">
          {{ item.description }}
        </div>
      </label>
    </div>
  </div>
</template>
<script setup>

const locale = useLocale();
const appConfig = useAppConfig();

const props = defineProps({
  options: Array,
  modelValue: Object,
});

const emit = defineEmits(['update:modelValue']);

const getDeliveryEstimation = (deliveryDays) => {
  return 0;
}

const updateSelectedId = (payment) => {
  if (payment.allowed) {
    emit('update:modelValue', { id: payment.id });
  }
}

watch([() => props.modelValue, () => props.options], () => {
  if (props.modelValue && props.options?.length) {
    useCart().prepareItemsForAnalyticsEvent().then(items => {
      const paymentName = props.options.find(q => q.id === props.modelValue?.id)?.name;

      if (paymentName) {
        useBaseAnalytics().pushEvent('add_payment_info', {
          ecommerce: {
            payment_type: paymentName,
            items: items
          }
        });
      }
    });
  }
});

const model = computed(() => props.modelValue?.id);

watch(() => props.options, (newValue) => {
  if (props.options?.length === 1 && props.modelValue?.id !== props.options[0].id) {
    updateSelectedId(props.options[0]);
  }
}, { deep: true });


</script>
<style lang="postcss">
.payment-selector__option {
  @apply border-t-[1px] border-neutral-200 px-4 py-6;

  &--not-allowed {
    * {
      @apply cursor-not-allowed;
    }

    .payment-selector__option__row {

      @apply cursor-not-allowed;

      .payment-selector__option__cell {
        @apply opacity-50;
      }

      img {
        @apply grayscale;
      }
    }
  }

  &__row {
    @apply flex flex-wrap items-start justify-between gap-2;
  }
}
</style>